const KEY = 'nwChunkReloaded';
const CHUNK_RE =
  /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS|error loading dynamically imported module/i;

/** True when a route chunk is gone from the server — usually because a new version was deployed. */
export function isChunkLoadError(err: unknown): boolean {
  if (err == null) return false;
  const msg = typeof err === 'string' ? err : err instanceof Error ? err.message : String((err as { message?: unknown }).message ?? '');
  return CHUNK_RE.test(msg);
}

function safe<T>(fn: () => T): T | undefined {
  try {
    return fn();
  } catch {
    return undefined; // storage can be blocked (private window)
  }
}

/** Vite fires `vite:preloadError` when a lazy chunk 404s after a deploy: reload once per session to fetch the new build. */
export function installChunkReload(win: Window, storage?: Storage): void {
  const store = storage ?? safe(() => win.sessionStorage);
  win.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    if (safe(() => store?.getItem(KEY)) === '1') return;
    safe(() => store?.setItem(KEY, '1'));
    win.location.reload();
  });
  // a healthy page load clears the guard, so the next deploy can reload again
  setTimeout(() => safe(() => store?.removeItem(KEY)), 10_000);
}
